<!-- title -->
<app-modal-title
  [title]="'common.add' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content tw-w-[450px]">
  <app-fields
    [isFromModal]="true"
    [formBuilderFieldsList]="formBuilderFieldsList"
    (fields)="setFields($event)"
  ></app-fields>

  <!-- form btns-->
  <app-form-btns
    [loading]="loading"
    (onClose)="onClose()"
    (onSubmit)="onSubmit()"
  >
  </app-form-btns>
</div>
